import type { ParsedLayout } from './types';

export const getFirstFoldableSectionIdx = (parsedAnswer: ParsedLayout): number => {
	let firstFoldableSectionIdx = -1;
	for (let i = 0; i < parsedAnswer.length; i++) {
		if (parsedAnswer[i].attributes?.folded === '1') {
			firstFoldableSectionIdx = i;
			break;
		}
	}

	return firstFoldableSectionIdx;
};
